import { FinanceValueObjectsTaxTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const TAX_TYPE = (key: FinanceValueObjectsTaxTypeEnum) => {
  switch (key) {
    case 'vat':
      return i18n.t('finance.modals.new_tax_type.fields.type_selector.options.vat')
    case 'personal_income':
      return i18n.t('finance.modals.new_tax_type.fields.type_selector.options.personal_income')
    default:
      key satisfies never
  }
}
